import { Injectable } from '@angular/core';
import { OrderStatus } from '@app/core/enums/order-status';
import { OrderHeader } from '@core/models/order-header.model';
import { OrderHelperService } from '@order/services/order-helper.service';
import { OrderHeaderViewModel } from '@shared/viewModels/order-header.viewModel';
import { OrderStatusViewModel } from '@shared/viewModels/order-status.viewModel';

@Injectable({
	providedIn: 'root'
})
export class OrderHeaderConverterService {

	constructor (
		private _orderHelperService: OrderHelperService
	) { }

	createOrderHeaderViewModel(orderHeader: OrderHeader): OrderHeaderViewModel {

		const orderHeaderVM = new OrderHeaderViewModel(orderHeader);

		orderHeaderVM.id = orderHeader.id || "";
		orderHeaderVM.customerName = orderHeader.advertiserName || "";
		orderHeaderVM.campaignName = orderHeader.campaignName || "";
		orderHeaderVM.statusVM = new OrderStatusViewModel(orderHeader);

		orderHeaderVM.net = orderHeader.priceNetIncTax;

		orderHeaderVM.products = orderHeader.packageLabels?.join(", ");
		orderHeaderVM.placements = orderHeader.placementLabels?.join(", ");
		orderHeaderVM.sizes = orderHeader.sizeLabels?.join(", ");

		orderHeaderVM.startDate = orderHeader.startDate || "";
		orderHeaderVM.endDate = orderHeader.endDate || "";
		orderHeaderVM.nextDate = orderHeader.nextDate || "";
		orderHeaderVM.adCount = orderHeader.adCount?.toString() || "";
		orderHeaderVM.adCountRemaining = orderHeader.adCountRemaining?.toString() || "";
		orderHeaderVM.poNumber = orderHeader.poNumber || "";

		orderHeaderVM.thumbnail = undefined; // orderHeader.thumbnail; <-- should be supported on Stage 2

		orderHeaderVM.agencyContactId = orderHeader?.agencyContactId;
		orderHeaderVM.otherPayerId = orderHeader?.otherPayerId;
		orderHeaderVM.otherPayerName = orderHeader.otherPayerName;

		orderHeaderVM.contactFirstName = orderHeader?.contactFirstName;
		orderHeaderVM.contactLastName = orderHeader?.contactLastName;
		orderHeaderVM.contactEmail = orderHeader?.contactEmail;
		orderHeaderVM.contactPhone = orderHeader?.contactPhone;

		orderHeaderVM.isConfirmationDeadlinePassed = Object.entries(orderHeader.statusCounts || {}).some(x => x[0] === OrderStatus.PastConfirmDeadline && (x[1] as number) > 0);
		orderHeaderVM.isConfirmationDeadlineApproaching = !orderHeaderVM.isConfirmationDeadlinePassed && Object.entries(orderHeader.statusCounts || {}).some(x => x[0] === OrderStatus.ConfirmDeadlineApproaching && (x[1] as number) > 0);

		return orderHeaderVM;
	}
}
